import { SFStack, SFIcons, SFButton } from "@sf-core";
import { useTranslation } from "react-i18next";
import { getSkillpathCertificate } from "../../services/courseService";
import { openLinkedinWindowPopup } from "../../helpers/openLinkedinWindowPopup";

const CourseButtons = ({labels, submitRating, popupClose}) => {
  const { t } = useTranslation();
  return (
    <SFStack direction="row" spacing={2}>
      <SFButton
        variant="transparent"
        onClick={() => {
          // Submit Rating and close course modal
          submitRating();
          popupClose();
        }}
      >
        {t(labels.buttonClose)}
      </SFButton>
      <SFButton
        variant="secondary"
        startIcon={<SFIcons.SFPlayIcon />}
        onClick={() => {
          // Submit Rating and close course modal and open next course
          submitRating();
          popupClose(true);
        }}
      >
        {t(labels.buttonNext)}
      </SFButton>
    </SFStack>
  );
};

const SkillpathButtons = ({modal, labels}) => {
  const { t } = useTranslation();
  return (
    <>
      <SFStack direction="row" spacing={2}>
        <SFButton
          variant="transparent"
          startIcon={<SFIcons.SFShareIcon />}
          onClick={() => openLinkedinWindowPopup(modal.userBadgeId)}
        >
          {t(labels.buttonShare)}
        </SFButton>
        <SFButton
          variant="transparent"
          startIcon={<SFIcons.SFDownloadIcon />}
          onClick={() =>
            getSkillpathCertificate(modal.userBadgeId, modal.title)
          }
        >
          {t(labels.buttonCertificate)}
        </SFButton>
      </SFStack>
    </>
  );
};

const RateButton = ({ labels, submitRating, popupClose }) => {
  const { t } = useTranslation();
  return (
    <SFButton
      variant="secondary"
      onClick={() => {
        // Submit Rating and close modal
        submitRating();
        popupClose();
      }}
    >
      {t(labels?.buttonRate)}
    </SFButton>
  );
};

export { CourseButtons, SkillpathButtons, RateButton };